module.exports = __webpack_public_path__ + "assets/img/8f55d27887998faf545ae993fd6dc8a2.png";